/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const customFetchPlant = /* GraphQL */ `query CustomFetchPlant($plantId: String) {
  customFetchPlant(plantId: $plantId)
}
` as GeneratedQuery<
  APITypes.CustomFetchPlantQueryVariables,
  APITypes.CustomFetchPlantQuery
>;
export const customGetCatalogSettings = /* GraphQL */ `query CustomGetCatalogSettings {
  customGetCatalogSettings
}
` as GeneratedQuery<
  APITypes.CustomGetCatalogSettingsQueryVariables,
  APITypes.CustomGetCatalogSettingsQuery
>;
export const customGetCompany = /* GraphQL */ `query CustomGetCompany($companyId: String) {
  customGetCompany(companyId: $companyId)
}
` as GeneratedQuery<
  APITypes.CustomGetCompanyQueryVariables,
  APITypes.CustomGetCompanyQuery
>;
export const customGetInventoryItem = /* GraphQL */ `query CustomGetInventoryItem($inventoryId: String) {
  customGetInventoryItem(inventoryId: $inventoryId)
}
` as GeneratedQuery<
  APITypes.CustomGetInventoryItemQueryVariables,
  APITypes.CustomGetInventoryItemQuery
>;
export const customGetObject = /* GraphQL */ `query CustomGetObject($objectId: String) {
  customGetObject(objectId: $objectId)
}
` as GeneratedQuery<
  APITypes.CustomGetObjectQueryVariables,
  APITypes.CustomGetObjectQuery
>;
export const customGetProject = /* GraphQL */ `query CustomGetProject($projectId: String) {
  customGetProject(projectId: $projectId)
}
` as GeneratedQuery<
  APITypes.CustomGetProjectQueryVariables,
  APITypes.CustomGetProjectQuery
>;
export const customGetProjectBoundary = /* GraphQL */ `query CustomGetProjectBoundary($projectId: String) {
  customGetProjectBoundary(projectId: $projectId)
}
` as GeneratedQuery<
  APITypes.CustomGetProjectBoundaryQueryVariables,
  APITypes.CustomGetProjectBoundaryQuery
>;
export const customListAvailableInventory = /* GraphQL */ `query CustomListAvailableInventory($companyId: String) {
  customListAvailableInventory(companyId: $companyId)
}
` as GeneratedQuery<
  APITypes.CustomListAvailableInventoryQueryVariables,
  APITypes.CustomListAvailableInventoryQuery
>;
export const customListCompanies = /* GraphQL */ `query CustomListCompanies {
  customListCompanies
}
` as GeneratedQuery<
  APITypes.CustomListCompaniesQueryVariables,
  APITypes.CustomListCompaniesQuery
>;
export const customListInventory = /* GraphQL */ `query CustomListInventory($companyId: String) {
  customListInventory(companyId: $companyId)
}
` as GeneratedQuery<
  APITypes.CustomListInventoryQueryVariables,
  APITypes.CustomListInventoryQuery
>;
export const customListObjects = /* GraphQL */ `query CustomListObjects {
  customListObjects
}
` as GeneratedQuery<
  APITypes.CustomListObjectsQueryVariables,
  APITypes.CustomListObjectsQuery
>;
export const customListPlants = /* GraphQL */ `query CustomListPlants {
  customListPlants
}
` as GeneratedQuery<
  APITypes.CustomListPlantsQueryVariables,
  APITypes.CustomListPlantsQuery
>;
export const customListProjects = /* GraphQL */ `query CustomListProjects {
  customListProjects
}
` as GeneratedQuery<
  APITypes.CustomListProjectsQueryVariables,
  APITypes.CustomListProjectsQuery
>;
export const customListProjectsByCompany = /* GraphQL */ `query CustomListProjectsByCompany($companyId: String) {
  customListProjectsByCompany(companyId: $companyId)
}
` as GeneratedQuery<
  APITypes.CustomListProjectsByCompanyQueryVariables,
  APITypes.CustomListProjectsByCompanyQuery
>;
export const customPingInventory = /* GraphQL */ `query CustomPingInventory {
  customPingInventory
}
` as GeneratedQuery<
  APITypes.CustomPingInventoryQueryVariables,
  APITypes.CustomPingInventoryQuery
>;
export const customTestInventory = /* GraphQL */ `query CustomTestInventory {
  customTestInventory
}
` as GeneratedQuery<
  APITypes.CustomTestInventoryQueryVariables,
  APITypes.CustomTestInventoryQuery
>;
export const getCompany = /* GraphQL */ `query GetCompany($company_id: String!) {
  getCompany(company_id: $company_id) {
    address
    business_hours
    company_id
    contact_email
    contact_phone
    createdAt
    description
    logo
    name
    service_areas
    timestamps
    updatedAt
    website
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyQueryVariables,
  APITypes.GetCompanyQuery
>;
export const getCustomer = /* GraphQL */ `query GetCustomer($pk: String!, $sk: String!) {
  getCustomer(pk: $pk, sk: $sk) {
    address
    billing_info
    createdAt
    notes
    pk
    preferences
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerQueryVariables,
  APITypes.GetCustomerQuery
>;
export const getItemInventory = /* GraphQL */ `query GetItemInventory($inventory_id: String!) {
  getItemInventory(inventory_id: $inventory_id) {
    company_id
    createdAt
    customer_price
    inventory_id
    item_id
    last_restocked
    location_in_warehouse
    quantity
    restock_threshold
    status
    supplier
    timestamps
    type
    unit_cost
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetItemInventoryQueryVariables,
  APITypes.GetItemInventoryQuery
>;
export const getLandscapeObject = /* GraphQL */ `query GetLandscapeObject($object_id: String!) {
  getLandscapeObject(object_id: $object_id) {
    category
    color
    createdAt
    dimensions
    images
    installation_difficulty
    maintenance_level
    manufacturer
    material
    name
    object_id
    price_range
    timestamps
    updatedAt
    weather_resistance
    weight
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLandscapeObjectQueryVariables,
  APITypes.GetLandscapeObjectQuery
>;
export const getPlant = /* GraphQL */ `query GetPlant($plant_id: String!) {
  getPlant(plant_id: $plant_id) {
    bloom_details
    common_names
    createdAt
    foliage
    growth_rate
    hardiness_zones
    height
    images
    lifecycle
    maintenance_level
    plant_id
    plant_type
    propagation_methods
    resistances
    scientific_name
    soil_ph_preferences
    special_features
    spread
    sunlight_requirements
    timestamps
    toxicity
    updatedAt
    water_preferences
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPlantQueryVariables, APITypes.GetPlantQuery>;
export const getProject = /* GraphQL */ `query GetProject($project_id: String!) {
  getProject(project_id: $project_id) {
    company_id
    createdAt
    created_by
    customer_id
    description
    end_date
    modified_by
    project_id
    project_name
    property_details
    proposal_status
    start_date
    status
    timestamps
    total_estimated_cost
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectQueryVariables,
  APITypes.GetProjectQuery
>;
export const getProjectComment = /* GraphQL */ `query GetProjectComment($pk: String!, $sk: String!) {
  getProjectComment(pk: $pk, sk: $sk) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectCommentQueryVariables,
  APITypes.GetProjectCommentQuery
>;
export const getProjectItem = /* GraphQL */ `query GetProjectItem($company_id: String!, $inventory_id: String!) {
  getProjectItem(company_id: $company_id, inventory_id: $inventory_id) {
    company_id
    createdAt
    inventory_id
    placement_coordinates
    placement_properties
    quantity
    status
    timestamps
    type
    unit_price
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectItemQueryVariables,
  APITypes.GetProjectItemQuery
>;
export const getProjectItemComment = /* GraphQL */ `query GetProjectItemComment($pk: String!, $sk: String!) {
  getProjectItemComment(pk: $pk, sk: $sk) {
    attachments
    comment_text
    coordinates
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectItemCommentQueryVariables,
  APITypes.GetProjectItemCommentQuery
>;
export const getTask = /* GraphQL */ `query GetTask($pk: String!, $sk: String!) {
  getTask(pk: $pk, sk: $sk) {
    assigned_to
    category
    createdAt
    description
    estimated_hours
    frequency
    pk
    priority
    project_item_id
    recurring_pattern
    scheduled_date
    sk
    status
    task_name
    timestamps
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTaskQueryVariables, APITypes.GetTaskQuery>;
export const getTaskComment = /* GraphQL */ `query GetTaskComment($pk: String!, $sk: String!) {
  getTaskComment(pk: $pk, sk: $sk) {
    attachments
    comment_text
    createdAt
    pk
    sk
    timestamps
    updatedAt
    user_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaskCommentQueryVariables,
  APITypes.GetTaskCommentQuery
>;
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $company_id: String
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanies(
    company_id: $company_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      address
      business_hours
      company_id
      contact_email
      contact_phone
      createdAt
      description
      logo
      name
      service_areas
      timestamps
      updatedAt
      website
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesQueryVariables,
  APITypes.ListCompaniesQuery
>;
export const listCustomerByUser_id = /* GraphQL */ `query ListCustomerByUser_id(
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $user_id: String!
) {
  listCustomerByUser_id(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    user_id: $user_id
  ) {
    items {
      address
      billing_info
      createdAt
      notes
      pk
      preferences
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomerByUser_idQueryVariables,
  APITypes.ListCustomerByUser_idQuery
>;
export const listCustomers = /* GraphQL */ `query ListCustomers(
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
  $pk: String
  $sk: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
) {
  listCustomers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pk: $pk
    sk: $sk
    sortDirection: $sortDirection
  ) {
    items {
      address
      billing_info
      createdAt
      notes
      pk
      preferences
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomersQueryVariables,
  APITypes.ListCustomersQuery
>;
export const listItemInventories = /* GraphQL */ `query ListItemInventories(
  $filter: ModelItemInventoryFilterInput
  $inventory_id: String
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listItemInventories(
    filter: $filter
    inventory_id: $inventory_id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      customer_price
      inventory_id
      item_id
      last_restocked
      location_in_warehouse
      quantity
      restock_threshold
      status
      supplier
      timestamps
      type
      unit_cost
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemInventoriesQueryVariables,
  APITypes.ListItemInventoriesQuery
>;
export const listItemInventoryByCompany_id = /* GraphQL */ `query ListItemInventoryByCompany_id(
  $company_id: String!
  $filter: ModelitemInventoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listItemInventoryByCompany_id(
    company_id: $company_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      customer_price
      inventory_id
      item_id
      last_restocked
      location_in_warehouse
      quantity
      restock_threshold
      status
      supplier
      timestamps
      type
      unit_cost
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemInventoryByCompany_idQueryVariables,
  APITypes.ListItemInventoryByCompany_idQuery
>;
export const listItemInventoryByItem_id = /* GraphQL */ `query ListItemInventoryByItem_id(
  $filter: ModelitemInventoryFilterInput
  $item_id: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listItemInventoryByItem_id(
    filter: $filter
    item_id: $item_id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      customer_price
      inventory_id
      item_id
      last_restocked
      location_in_warehouse
      quantity
      restock_threshold
      status
      supplier
      timestamps
      type
      unit_cost
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemInventoryByItem_idQueryVariables,
  APITypes.ListItemInventoryByItem_idQuery
>;
export const listLandscapeObjects = /* GraphQL */ `query ListLandscapeObjects(
  $filter: ModelLandscapeObjectFilterInput
  $limit: Int
  $nextToken: String
  $object_id: String
  $sortDirection: ModelSortDirection
) {
  listLandscapeObjects(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    object_id: $object_id
    sortDirection: $sortDirection
  ) {
    items {
      category
      color
      createdAt
      dimensions
      images
      installation_difficulty
      maintenance_level
      manufacturer
      material
      name
      object_id
      price_range
      timestamps
      updatedAt
      weather_resistance
      weight
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLandscapeObjectsQueryVariables,
  APITypes.ListLandscapeObjectsQuery
>;
export const listPlants = /* GraphQL */ `query ListPlants(
  $filter: ModelPlantFilterInput
  $limit: Int
  $nextToken: String
  $plant_id: String
  $sortDirection: ModelSortDirection
) {
  listPlants(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    plant_id: $plant_id
    sortDirection: $sortDirection
  ) {
    items {
      bloom_details
      common_names
      createdAt
      foliage
      growth_rate
      hardiness_zones
      height
      images
      lifecycle
      maintenance_level
      plant_id
      plant_type
      propagation_methods
      resistances
      scientific_name
      soil_ph_preferences
      special_features
      spread
      sunlight_requirements
      timestamps
      toxicity
      updatedAt
      water_preferences
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlantsQueryVariables,
  APITypes.ListPlantsQuery
>;
export const listProjectByCompany_id = /* GraphQL */ `query ListProjectByCompany_id(
  $company_id: String!
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectByCompany_id(
    company_id: $company_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      created_by
      customer_id
      description
      end_date
      modified_by
      project_id
      project_name
      property_details
      proposal_status
      start_date
      status
      timestamps
      total_estimated_cost
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectByCompany_idQueryVariables,
  APITypes.ListProjectByCompany_idQuery
>;
export const listProjectByCustomer_id = /* GraphQL */ `query ListProjectByCustomer_id(
  $customer_id: String!
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectByCustomer_id(
    customer_id: $customer_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      created_by
      customer_id
      description
      end_date
      modified_by
      project_id
      project_name
      property_details
      proposal_status
      start_date
      status
      timestamps
      total_estimated_cost
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectByCustomer_idQueryVariables,
  APITypes.ListProjectByCustomer_idQuery
>;
export const listProjectCommentByUser_id = /* GraphQL */ `query ListProjectCommentByUser_id(
  $filter: ModelProjectCommentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $user_id: String!
) {
  listProjectCommentByUser_id(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    user_id: $user_id
  ) {
    items {
      attachments
      comment_text
      coordinates
      createdAt
      pk
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectCommentByUser_idQueryVariables,
  APITypes.ListProjectCommentByUser_idQuery
>;
export const listProjectComments = /* GraphQL */ `query ListProjectComments(
  $filter: ModelProjectCommentFilterInput
  $limit: Int
  $nextToken: String
  $pk: String
  $sk: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
) {
  listProjectComments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pk: $pk
    sk: $sk
    sortDirection: $sortDirection
  ) {
    items {
      attachments
      comment_text
      coordinates
      createdAt
      pk
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectCommentsQueryVariables,
  APITypes.ListProjectCommentsQuery
>;
export const listProjectItemByInventory_id = /* GraphQL */ `query ListProjectItemByInventory_id(
  $filter: ModelProjectItemFilterInput
  $inventory_id: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectItemByInventory_id(
    filter: $filter
    inventory_id: $inventory_id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      inventory_id
      placement_coordinates
      placement_properties
      quantity
      status
      timestamps
      type
      unit_price
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectItemByInventory_idQueryVariables,
  APITypes.ListProjectItemByInventory_idQuery
>;
export const listProjectItemCommentByUser_id = /* GraphQL */ `query ListProjectItemCommentByUser_id(
  $filter: ModelProjectItemCommentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $user_id: String!
) {
  listProjectItemCommentByUser_id(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    user_id: $user_id
  ) {
    items {
      attachments
      comment_text
      coordinates
      createdAt
      pk
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectItemCommentByUser_idQueryVariables,
  APITypes.ListProjectItemCommentByUser_idQuery
>;
export const listProjectItemComments = /* GraphQL */ `query ListProjectItemComments(
  $filter: ModelProjectItemCommentFilterInput
  $limit: Int
  $nextToken: String
  $pk: String
  $sk: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
) {
  listProjectItemComments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pk: $pk
    sk: $sk
    sortDirection: $sortDirection
  ) {
    items {
      attachments
      comment_text
      coordinates
      createdAt
      pk
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectItemCommentsQueryVariables,
  APITypes.ListProjectItemCommentsQuery
>;
export const listProjectItems = /* GraphQL */ `query ListProjectItems(
  $company_id: String
  $filter: ModelProjectItemFilterInput
  $inventory_id: ModelStringKeyConditionInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectItems(
    company_id: $company_id
    filter: $filter
    inventory_id: $inventory_id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      inventory_id
      placement_coordinates
      placement_properties
      quantity
      status
      timestamps
      type
      unit_price
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectItemsQueryVariables,
  APITypes.ListProjectItemsQuery
>;
export const listProjects = /* GraphQL */ `query ListProjects(
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
  $project_id: String
  $sortDirection: ModelSortDirection
) {
  listProjects(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    project_id: $project_id
    sortDirection: $sortDirection
  ) {
    items {
      company_id
      createdAt
      created_by
      customer_id
      description
      end_date
      modified_by
      project_id
      project_name
      property_details
      proposal_status
      start_date
      status
      timestamps
      total_estimated_cost
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectsQueryVariables,
  APITypes.ListProjectsQuery
>;
export const listTaskByAssigned_to = /* GraphQL */ `query ListTaskByAssigned_to(
  $assigned_to: String!
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTaskByAssigned_to(
    assigned_to: $assigned_to
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      assigned_to
      category
      createdAt
      description
      estimated_hours
      frequency
      pk
      priority
      project_item_id
      recurring_pattern
      scheduled_date
      sk
      status
      task_name
      timestamps
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskByAssigned_toQueryVariables,
  APITypes.ListTaskByAssigned_toQuery
>;
export const listTaskByProject_item_id = /* GraphQL */ `query ListTaskByProject_item_id(
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
  $project_item_id: String!
  $sortDirection: ModelSortDirection
) {
  listTaskByProject_item_id(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    project_item_id: $project_item_id
    sortDirection: $sortDirection
  ) {
    items {
      assigned_to
      category
      createdAt
      description
      estimated_hours
      frequency
      pk
      priority
      project_item_id
      recurring_pattern
      scheduled_date
      sk
      status
      task_name
      timestamps
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskByProject_item_idQueryVariables,
  APITypes.ListTaskByProject_item_idQuery
>;
export const listTaskByStatus = /* GraphQL */ `query ListTaskByStatus(
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $status: String!
) {
  listTaskByStatus(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    status: $status
  ) {
    items {
      assigned_to
      category
      createdAt
      description
      estimated_hours
      frequency
      pk
      priority
      project_item_id
      recurring_pattern
      scheduled_date
      sk
      status
      task_name
      timestamps
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskByStatusQueryVariables,
  APITypes.ListTaskByStatusQuery
>;
export const listTaskCommentByUser_id = /* GraphQL */ `query ListTaskCommentByUser_id(
  $filter: ModelTaskCommentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $user_id: String!
) {
  listTaskCommentByUser_id(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    user_id: $user_id
  ) {
    items {
      attachments
      comment_text
      createdAt
      pk
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskCommentByUser_idQueryVariables,
  APITypes.ListTaskCommentByUser_idQuery
>;
export const listTaskComments = /* GraphQL */ `query ListTaskComments(
  $filter: ModelTaskCommentFilterInput
  $limit: Int
  $nextToken: String
  $pk: String
  $sk: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
) {
  listTaskComments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pk: $pk
    sk: $sk
    sortDirection: $sortDirection
  ) {
    items {
      attachments
      comment_text
      createdAt
      pk
      sk
      timestamps
      updatedAt
      user_id
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskCommentsQueryVariables,
  APITypes.ListTaskCommentsQuery
>;
export const listTasks = /* GraphQL */ `query ListTasks(
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
  $pk: String
  $sk: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
) {
  listTasks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pk: $pk
    sk: $sk
    sortDirection: $sortDirection
  ) {
    items {
      assigned_to
      category
      createdAt
      description
      estimated_hours
      frequency
      pk
      priority
      project_item_id
      recurring_pattern
      scheduled_date
      sk
      status
      task_name
      timestamps
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTasksQueryVariables, APITypes.ListTasksQuery>;
export const sayHello = /* GraphQL */ `query SayHello($name: String) {
  sayHello(name: $name)
}
` as GeneratedQuery<APITypes.SayHelloQueryVariables, APITypes.SayHelloQuery>;
